export const ALL_DATABASES = "__ALL_DATABASES__";

export const ALL_ENGINES = "__ALL_ENGINES__";

export const ALL_ACCOUNTS = "__ALL_ACCOUNTS__";
export const ALL_LOGINS = "__ALL_LOGINS__";
export const ALL_SERVICE_ACCOUNTS = "__ALL_SERVICE_ACCOUNTS__";
export const ALL_NETWORK_POLICIES = "__ALL_NETWORK_POLICIES__";
export const ALL_ROLES = "__ALL_ROLES__";

export const ALL_TABLES = "__ALL_TABLES__";

export const ALL_VIEWS = "__ALL_VIEWS__";

export const ALL_SCHEMAS = "__ALL_SCHEMAS__";

export const ALL_TABLES_ALL_DATABASES = "__ALL_TABLES_ALL_DATABASES__";
export const ALL_VIEWS_ALL_DATABASES = "__ALL_VIEWS_ALL_DATABASES__";
export const ALL_SCHEMAS_ALL_DATABASES = "__ALL_SCHEMAS_ALL_DATABASES__";

export const CLEAR_ALL = "__CLEAR_ALL__";
export const SELECT_ALL = "__SELECT_ALL__";

export const ALL_ITEMS = [
  ALL_ACCOUNTS,
  ALL_LOGINS,
  ALL_SERVICE_ACCOUNTS,
  ALL_ROLES,
  ALL_NETWORK_POLICIES,
  ALL_ENGINES,
  ALL_DATABASES,
];

export const bulkItemTitleMap = {
  [ALL_ACCOUNTS]: "roles_wizard.privileges.all_accounts",
  [ALL_LOGINS]: "roles_wizard.privileges.all_logins",
  [ALL_SERVICE_ACCOUNTS]: "roles_wizard.privileges.all_service_accounts",
  [ALL_ROLES]: "roles_wizard.privileges.all_roles",
  [ALL_NETWORK_POLICIES]: "roles_wizard.privileges.all_network_policies",
  [ALL_ENGINES]: "roles_wizard.privileges.all_engines",
  [ALL_TABLES]: "roles_wizard.privileges.all_tables",
  [ALL_DATABASES]: "roles_wizard.privileges.all_databases",
  [ALL_TABLES_ALL_DATABASES]: "roles_wizard.privileges.all_tables",
  [ALL_VIEWS]: "roles_wizard.privileges.all_views",
  [ALL_VIEWS_ALL_DATABASES]: "roles_wizard.privileges.all_views",
  [ALL_SCHEMAS]: "roles_wizard.privileges.all_schemas",
  [ALL_SCHEMAS_ALL_DATABASES]: "roles_wizard.privileges.all_schemas",
};
